import { abortIfNotPermitted } from '../utils';

export default [
    {
        path: '/',
        component: () =>
            import(/* webpackChunkName: "attendant-tagging" */ '@js/franchise_component/attendant-tagging/attendant-tagging-index.vue'),
        beforeEnter: (to, from, next) => {
            abortIfNotPermitted('franchise_view_attendant_tagging', next);
        },
        meta: {
            keepAlive: false,
        },
    },
    {
        path: '/:id',
        component: () =>
            import(/* webpackChunkName: "attendant-tagging" */ `@js/franchise_component/attendant-tagging/attendant-tagging-show.vue`),
        beforeEnter: (to, from, next) => {
            abortIfNotPermitted('franchise_view_attendant_tagging', next);
        },
        meta: {
            keepAlive: false,
        },
    },
];
